import styled, { css } from 'styled-components/macro'

import { getToken, toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { type TimelinePosition } from './TimelineItem'

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-items: flex-start;
  gap: ${getToken('spacing-4')};
  width: 100%;
`

export const Timeline = styled.div<{ position: TimelinePosition }>`
  box-sizing: border-box;
  display: flex;
  align-items: ${({ position }) => (position === 'first' ? 'flex-end' : 'stretch')};
`

export const Line = styled.div<{ position: TimelinePosition }>`
  box-sizing: border-box;
  width: 12px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: 'flex-start';
  background-color: ${toCSSValue('color-background-tertiary')};
  padding: 2px 0;

  ${({ position }) =>
    position === 'first' &&
    css`
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    `}

  ${({ position }) =>
    position === 'last' &&
    css`
      height: 12px;
      align-items: flex-end;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    `}
`

export const Dot = styled.div`
  box-sizing: border-box;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${toCSSValue('color-primary-60')};
`

export const Content = styled.div<{ position: TimelinePosition }>`
  flex-grow: 1;

  ${({ position }) =>
    position !== 'last' &&
    css`
      padding-bottom: ${getToken('spacing-4')};
    `}
`
